/**
 * @generated SignedSource<<3b88d0322cb3263db0f076c3ca228347>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountView_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountMessage_transaction">;
  readonly " $fragmentType": "CheckoutBankAccountView_transaction";
};
export type CheckoutBankAccountView_transaction$key = {
  readonly " $data"?: CheckoutBankAccountView_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountView_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountView_transaction",
  "selections": [
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutBankAccountMessage_transaction"
        }
      ]
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "86db34a904236fa5b000889544b08115";

export default node;
